<template>
  <b-modal id="cart-prompt-modal" centered hide-header hide-footer>
    <b-container>
      <b-row class="my-3">
        <b-col class="text-center" v-if="cart && cart.message">
          {{ cart.message }}
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col class="ml-md-auto" md="3">
          <b-button
            v-if="webDesign !== null && webDesign.design !== null"
            pill
            block
            :style="{
              backgroundColor: webDesign.design.main_color + '!important',
              border: 'none !important',
              color: webDesign.design.button_text_color + '!important',
            }"
            @click="hideCartPromptModal()"
          >
            OK
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "CartPromptModal",
  computed: {
    ...mapState("estore", {
      webDesign: (state) => state.webDesign,
      cart: (state) => state.cart,
    }),
  },
  methods: {
    hideCartPromptModal() {
      this.$root.$emit('bv::hide::modal', 'cart-prompt-modal');
      this.$root.$emit('resetCheckoutErrorMessage');
    }
  }
};
</script>

<style>
</style>